export const PREFERRED_RATE_ONBOARDING_TOTAL_STEPS = 4;
